import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { Calendar, CalendarClock, Plus } from 'lucide-react';
import Section from '@/components/Section';
import { Button } from '@/components/ui/button';
import useCalendars from '@/hooks/useCalendars';
import { ICalendar } from '@/types';
import DataTable from '../DataTable/DataTable';
import Time from '../Time';

const Calendars = () => {
  const calendars = useCalendars();
  const drawer = useModal('calendar-drawer');
  const availablityDrawer = useModal('calendar-drawer');
  const data = useMemo(() => calendars.data || [], [calendars.data]);

  const columns: ColumnDef<ICalendar>[] = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Calendar',
        cell: ({ row }) => {
          return (
            <>
              <Button
                variant={'outline'}
                className="py-1.5 rounded-full px-2 text-sm cursor-pointer"
                onClick={() => {
                  drawer.show({ calendar: row.original });
                }}
              >
                <div className="flex items-center gap-2">
                  <Calendar />
                  {row.original.name}
                  <div
                    className="w-4 h-4 rounded-full"
                    style={{
                      backgroundColor: row.original.color,
                    }}
                  />
                </div>
              </Button>
            </>
          );
        },
      },
      {
        accessorKey: 'description',
        header: 'Description',
        cell: ({ row }) => <>{row.original.description}</>,
      },
      {
        accessorKey: 'created_at',
        header: 'Created',
        cell: ({ row }) => <Time>{row.original.created_at}</Time>,
      },
      {
        accessorKey: 'created_at',
        header: 'Updated',
        cell: ({ row }) => <Time>{row.original.updated_at}</Time>,
      },
      {
        accessorKey: 'timezone',
        header: 'Timezone',
        cell: ({ row }) => <Time>{row.original.updated_at}</Time>,
      },
      {
        header: 'Actions',
        cell: ({ row }) => (
          <div className="flex items-center gap-2">
            <Button
              onClick={() => {
                availablityDrawer.show({ contactList: row.original });
              }}
            >
              <CalendarClock />
              Availability
            </Button>
            <Button
              onClick={() => {
                availablityDrawer.show({ contactList: row.original });
              }}
            >
              <Calendar />
              Calendar
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4">
          <Calendar />
          <div className="text-lg font-bold">Calendars</div>
        </div>
        <Button className="ml-auto" onClick={() => drawer.show()}>
          <Plus />
          Add Calendar
        </Button>
      </div>

      <Section>
        <DataTable data={data} columns={columns} model={calendars} />
      </Section>
    </div>
  );
};

export default Calendars;
